import React, {FC, ReactNode} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {DropdownItemIcon} from '../../../common/dropdowns/dropdownItemIcon';
import {DropdownItemSecondaryIcon} from '../../../common/dropdowns/dropdownItemSecondaryIcon';

/*
 * Props.
 */

interface CellsRefinementOptionsSearchDropdownNavigationItemProps {
  label: ReactNode;
  iconName: IconName;
  onSelect: Handler;
}

/*
 * Component.
 */

export const CellsRefinementOptionsSearchDropdownNavigationItem: FC<
  CellsRefinementOptionsSearchDropdownNavigationItemProps
> = (props) => {
  const {label, iconName, onSelect} = props;
  return (
    <DropdownItem onSelect={onSelect}>
      <DropdownItemIcon iconName={iconName} iconSize={20} label={label} />
      <DropdownItemContent>{label}</DropdownItemContent>
      <DropdownItemSecondaryIcon iconName="chevronRightSmall" label={label} />
    </DropdownItem>
  );
};
